import { createFrontendModule } from '@backstage/frontend-plugin-api';

import { AzureDevOpsProjectPickerFieldExtension } from './AzureDevOpsProjectPicker';
import { AzureDevOpsAgentPoolPickerFieldExtension } from './AzureDevOpsAgentPoolPicker';

export const autoOnboardingModule = createFrontendModule({
  pluginId: 'scaffolder',

  extensions: [
    AzureDevOpsProjectPickerFieldExtension,
    AzureDevOpsAgentPoolPickerFieldExtension,
  ],
});
